import { jsx as y, Fragment as $, jsxs as je } from "react/jsx-runtime";
import { createContext as ce, useState as Ae, useContext as P, useMemo as b, useRef as Me, useEffect as Ie, useId as Ce } from "react";
import n, { z as c } from "zod";
import { JsonLd as D } from "react-schemaorg";
import { useEffectOnce as Le } from "@made-people/react-use-effect-once";
import { isProductMediaImage as Fe } from "@made-people/grease-product";
const xe = n.object({
  "@type": n.literal("BreadcrumbList"),
  itemListElement: n.array(
    n.object({
      "@type": n.literal("ListItem"),
      position: n.number(),
      item: n.object({
        name: n.string(),
        "@id": n.string()
      })
    })
  )
}), Ue = xe;
function ze(e) {
  const t = Ue.safeParse(e);
  return t.success, t.success;
}
var k = /* @__PURE__ */ ((e) => (e.FAQPage = "FAQPage", e.Product = "Product", e.ProductList = "ProductList", e.MerchantReturnPolicy = "MerchantReturnPolicy", e.ShippingRateSettings = "ShippingRateSettings", e.WebSite = "WebSite", e))(k || {});
const Ne = {
  structuredDataScripts: {},
  addToScripts: () => {
  },
  removeFromScripts: () => {
  }
}, N = ce(Ne), Ee = ({
  children: e
}) => {
  const [t, i] = Ae({}), s = (u, o) => {
    u in t && typeof t[u] < "u" && console.info(
      "Structured data script already exists, overwriting it...",
      u
    ), i({ ...t, [u]: o });
  }, a = (u) => {
    if (!(u in t))
      return;
    const { [u]: o, ...r } = t;
    i(r);
  };
  return /* @__PURE__ */ y(
    N.Provider,
    {
      value: {
        structuredDataScripts: t,
        addToScripts: s,
        removeFromScripts: a
      },
      children: e
    }
  );
}, Ve = () => {
  const { structuredDataScripts: e } = P(N);
  return e;
}, We = () => {
  const { addToScripts: e } = P(N);
  return e;
}, Kt = () => {
  const { removeFromScripts: e } = P(N);
  return e;
}, w = ce(void 0), Jt = (e) => {
  const t = {
    mappers: e.mappers,
    pdpProduct: e.pdpProduct,
    context: e.context,
    offerShippingDetailsSettings: e.offerShippingDetailsSettings,
    merchantReturnPolicySettings: e.merchantReturnPolicySettings,
    breadCrumbs: e.breadCrumbs
  };
  return /* @__PURE__ */ y(w.Provider, { value: t, children: /* @__PURE__ */ y(Ee, { children: e.children }) });
}, Xt = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "useStructuredDataMappers must be used within a StructuredDataProvider"
    );
  return e.mappers;
}, Qe = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "usePdpProduct must be used within a StructuredDataProvider"
    );
  return e.pdpProduct;
}, R = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "useStructuredDataContext must be used within a StructuredDataProvider"
    );
  return e.context;
}, $e = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "useShippingDetailsSettings must be used within a StructuredDataProvider"
    );
  return e.offerShippingDetailsSettings;
}, qe = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "useBreadCrumbs must be used within a StructuredDataProvider"
    );
  return e.breadCrumbs;
}, Be = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "useMerchantReturnPolicySettings must be used within a StructuredDataProvider"
    );
  return e.merchantReturnPolicySettings;
}, He = () => {
  const e = qe(), { baseUrl: t, siteSlug: i } = R(), s = b(() => {
    if (typeof e > "u" || typeof t > "u" || typeof i > "u")
      return;
    const a = {
      "@type": "BreadcrumbList",
      itemListElement: e.map((u, o) => {
        const r = u.slug === "" ? u.slug : `/${u.slug}`;
        return {
          "@type": "ListItem",
          position: o,
          item: {
            name: u.label,
            "@id": `${t}/${i}${r}`
          }
        };
      })
    };
    if (ze(a))
      return a;
  }, [e, t]);
  return typeof s > "u" ? null : /* @__PURE__ */ y(
    D,
    {
      item: {
        "@context": "https://schema.org",
        ...s
      }
    }
  );
}, Ge = n.enum([
  "BackOrder",
  "Discontinued",
  "InStock",
  "InStoreOnly",
  "LimitedAvailability",
  "OnlineOnly",
  "OutOfStock",
  "PreOrder",
  "PreSale",
  "SoldOut"
]), q = Ge;
function Yt(e) {
  const t = q.safeParse(e);
  return t.success, t.success;
}
const _e = n.object({
  "@type": n.literal("MonetaryAmount"),
  value: n.number().optional(),
  minValue: n.number().optional(),
  maxValue: n.number().optional(),
  currency: n.string()
}).refine(
  ({ maxValue: e, minValue: t, value: i }) => typeof e > "u" && typeof t > "u" && typeof i == "number" || typeof e == "number" && typeof t == "number" && typeof i > "u",
  {
    message: "Either both `minValue` and `maxValue` or only `value` have to be defined"
  }
), U = _e;
function pe(e) {
  const t = U.safeParse(e);
  return t.success, t.success;
}
const Ke = n.object({
  "@type": n.literal("DefinedRegion"),
  addressCountry: n.string().nonempty(),
  addressRegion: n.string().nonempty().optional()
}), B = Ke;
function Je(e) {
  const t = B.safeParse(e);
  return t.success, t.success;
}
const Xe = n.object({
  "@type": n.literal("QuantitativeValue"),
  minValue: n.number(),
  maxValue: n.number(),
  unitCode: n.string()
}).transform((e, t) => {
  switch (e.unitCode) {
    case "min":
    case "minutes": {
      e.unitCode = "min";
      break;
    }
    case "h":
    case "hours": {
      e.unitCode = "h";
      break;
    }
    case "days":
    case "d": {
      e.unitCode = "d";
      break;
    }
    case "wk":
    case "weeks": {
      e.unitCode = "wk";
      break;
    }
    default: {
      t.addIssue({
        fatal: !0,
        path: t.path,
        code: "invalid_enum_value",
        received: e.unitCode,
        options: ["minutes", "hours", "d", "weeks"]
      });
      break;
    }
  }
  return e;
}), z = Xe;
function Zt(e) {
  const t = z.safeParse(e);
  return t.success, t.success;
}
function se(e) {
  const t = z.safeParse(e);
  if (t.success)
    return t.data;
}
const Ye = n.enum([
  "Monday",
  "https://schema.org/Monday",
  "Tuesday",
  "https://schema.org/Tuesday",
  "Wednesday",
  "https://schema.org/Wednesday",
  "Thursday",
  "https://schema.org/Thursday",
  "Friday",
  "https://schema.org/Friday",
  "Saturday",
  "https://schema.org/Saturday",
  "Sunday",
  "https://schema.org/Sunday"
]), fe = Ye;
function en(e) {
  const t = fe.safeParse(e);
  return t.success, t.success;
}
const Ze = n.object({
  "@type": n.literal("ShippingDeliveryTime"),
  cutoffTime: n.string().nonempty().optional(),
  handlingTime: z.optional(),
  transitTime: z.optional(),
  businessDays: n.object({
    "@type": n.literal("OpeningHoursSpecification"),
    dayOfWeek: fe.array()
  })
}), de = Ze;
function et(e) {
  const t = de.safeParse(e);
  return t.success, t.success;
}
const tt = n.object({
  "@type": n.literal("OfferShippingDetails"),
  shippingSettingsLink: n.string(),
  deliveryTime: de.optional(),
  shippingRate: U,
  shippingDestination: B
}), le = tt;
function nt(e) {
  const t = le.safeParse(e);
  return t.success, t.success;
}
const it = n.object({
  "@type": n.literal("Offer"),
  price: n.number(),
  name: n.string().optional(),
  priceCurrency: n.string(),
  availability: q,
  shippingDetails: le.optional()
}), H = it;
function tn(e) {
  const t = H.safeParse(e);
  return t.success, t.success;
}
const rt = n.object({
  "@type": n.literal("SizeSpecification"),
  name: n.string().nonempty(),
  sizeSystem: n.string().nonempty().optional(),
  sizeGroup: n.string().nonempty().optional()
}), st = n.object({
  "@type": n.literal("ProductModel"),
  sku: n.string().nonempty(),
  name: n.string().nonempty(),
  mpn: n.string().nonempty().optional(),
  size: n.union([n.string().nonempty(), rt]).optional(),
  image: n.string().array().nonempty().optional(),
  color: n.string().nonempty().optional(),
  offers: H,
  url: n.string()
}).refine(
  (e) => !(typeof e.size > "u" && typeof e.color > "u"),
  {
    message: "Both `size` and `color` cannot be undefined simultaneously on a product model"
  }
), G = st;
function nn(e) {
  return G.safeParse(e).success;
}
function ot(e) {
  if (typeof e > "u")
    return;
  const t = G.safeParse(e);
  if (t.success)
    return t.data;
}
const at = n.object({
  "@type": n.literal("AggregateOffer"),
  lowPrice: n.number(),
  highPrice: n.number(),
  name: n.string().optional(),
  priceCurrency: n.string(),
  availability: q
}), ge = at;
function rn(e) {
  const t = ge.safeParse(e);
  return t.success, t.success;
}
const ut = n.object({
  "@type": n.literal("AggregateRating"),
  ratingValue: n.union([n.number(), n.string()]),
  bestRating: n.union([n.number(), n.string()]).optional(),
  worstRating: n.union([n.number(), n.string()]).optional(),
  ratingCount: n.number().int().positive().optional(),
  reviewCount: n.number().int().positive().optional()
}), _ = ut;
function sn(e) {
  return _.safeParse(e).success;
}
function on(e) {
  const t = _.safeParse(e);
  if (t.success)
    return t.data;
}
const ct = n.object({
  "@type": n.literal("Rating"),
  ratingValue: n.union([n.number(), n.string()]),
  bestRating: n.union([n.number(), n.string()]).optional(),
  worstRating: n.union([n.number(), n.string()]).optional(),
  author: n.union([
    n.object({
      "@type": n.literal("Person"),
      name: n.string()
    }),
    n.object({
      "@type": n.literal("Organization"),
      name: n.string()
    })
  ]).optional()
}), K = ct;
function an(e) {
  return K.safeParse(e).success;
}
function un(e) {
  const t = K.safeParse(e);
  if (t.success)
    return t.data;
}
const pt = n.object({
  "@type": n.literal("Review"),
  reviewBody: n.string().optional(),
  reviewRating: K.optional(),
  author: n.union([
    n.object({
      "@type": n.literal("Person"),
      name: n.string()
    }),
    n.object({
      "@type": n.literal("Organization"),
      name: n.string()
    })
  ]).optional(),
  datePublished: n.string().optional(),
  name: n.string().optional(),
  description: n.string().optional(),
  reviewAspect: n.string().optional(),
  positiveNotes: n.string().optional(),
  negativeNotes: n.string().optional()
}), J = pt;
function cn(e) {
  return J.safeParse(e).success;
}
function pn(e) {
  const t = J.safeParse(e);
  if (t.success)
    return t.data;
}
const ft = n.object({
  "@type": n.literal("MerchantReturnPolicy"),
  applicableCountry: n.string().optional(),
  returnPolicyCategory: n.enum([
    "MerchantReturnFiniteReturnWindow",
    "MerchantReturnNotPermitted",
    "MerchantReturnUnlimitedWindow",
    "MerchantReturnUnspecified"
  ]).optional(),
  merchantReturnDays: n.number().min(0).optional(),
  returnMethod: n.enum(["ReturnAtKiosk", "ReturnByMail", "ReturnInStore"]).optional(),
  returnFees: n.enum([
    "FreeReturn",
    "ReturnFeesCustomerResponsibility",
    "ReturnShippingFees"
  ]).optional(),
  inStoreReturnsOffered: n.boolean().optional()
}), me = ft;
function fn(e) {
  const t = me.safeParse(e);
  return t.success, t.success;
}
const dt = n.object({
  "@type": n.literal("Product"),
  sku: n.string().nonempty(),
  name: n.string().nonempty(),
  description: n.string().nonempty().optional(),
  image: n.string().array().nonempty().optional(),
  offers: H.or(ge),
  model: n.array(G).nonempty().optional(),
  url: n.string(),
  aggregateRating: _.optional(),
  review: n.array(J).optional(),
  hasMerchantReturnPolicy: me.optional()
}).refine(
  (e) => {
    var t;
    return !(typeof e.model < "u" && ((t = e.offers) == null ? void 0 : t["@type"]) === "Offer");
  },
  {
    message: "If `model` is defined, `offers` need to be of type 'AggregateOffer'"
  }
).refine(
  (e) => {
    var t;
    return !(typeof e.model > "u" && ((t = e.offers) == null ? void 0 : t["@type"]) === "AggregateOffer");
  },
  {
    message: "If `model` is undefined, `offers` need to be of type 'Offer'"
  }
).refine(
  (e) => !(typeof e.model > "u" && typeof e.offers > "u"),
  { message: "Both `model` and `offers` cannot be undefined simultaneously" }
), X = dt;
function lt(e) {
  return X.safeParse(e).success;
}
function gt(e) {
  const t = X.safeParse(e);
  if (t.success)
    return t.data;
}
const mt = n.object({
  "@type": n.literal("ItemList"),
  itemListElement: n.array(
    n.object({
      "@type": n.literal("ListItem"),
      position: n.number(),
      item: X
    })
  )
}), ye = mt;
function yt(e) {
  return ye.safeParse(e).success;
}
function dn(e) {
  const t = ye.safeParse(e);
  if (t.success)
    return t.data;
}
const he = c.object({
  applicableCountry: c.string().optional(),
  returnPolicyCategory: c.enum([
    "MerchantReturnFiniteReturnWindow",
    "MerchantReturnNotPermitted",
    "MerchantReturnUnlimitedWindow",
    "MerchantReturnUnspecified"
  ]).optional(),
  merchantReturnDays: c.number().min(0).optional(),
  returnMethod: c.enum(["ReturnAtKiosk", "ReturnByMail", "ReturnInStore"]).optional(),
  returnFees: c.enum([
    "FreeReturn",
    "ReturnFeesCustomerResponsibility",
    "ReturnShippingFees"
  ]).optional(),
  inStoreReturnsOffered: c.boolean().optional()
});
function ln(e) {
  return he.safeParse(e).success;
}
const Se = he.array().nonempty();
function ht(e) {
  return Se.safeParse(e).success;
}
function gn(e, t) {
  const i = Se.safeParse(e);
  if (!i.success) {
    t == null || t(i.error);
    return;
  }
  return i.data;
}
const St = (e) => {
  const { country: t, baseUrl: i } = R();
  return b(() => {
    var a, u, o, r, p, d;
    return ht(e) ? {
      "@type": "MerchantReturnPolicy",
      applicableCountry: ((a = e == null ? void 0 : e[0]) == null ? void 0 : a.applicableCountry) || t,
      returnPolicyCategory: (u = e == null ? void 0 : e[0]) == null ? void 0 : u.returnPolicyCategory,
      merchantReturnDays: (o = e == null ? void 0 : e[0]) == null ? void 0 : o.merchantReturnDays,
      returnMethod: (r = e == null ? void 0 : e[0]) == null ? void 0 : r.returnMethod,
      returnFees: (p = e == null ? void 0 : e[0]) == null ? void 0 : p.returnFees,
      inStoreReturnsOffered: (d = e == null ? void 0 : e[0]) == null ? void 0 : d.inStoreReturnsOffered
    } : void 0;
  }, [e, t, i]);
}, oe = c.object({
  unit: c.enum(["days", "hours", "minutes", "seconds"]),
  endTime: c.number(),
  startTime: c.number(),
  isEnabled: c.boolean()
}), be = c.object({
  cutoffTime: c.string().optional(),
  handlingTime: oe,
  transitTime: oe
});
function mn(e) {
  const t = be.safeParse(e);
  return t.success || console.warn(
    "Failed to parse type shippingDeliveryTimeSettingSchema: ",
    t.error
  ), t.success;
}
const ve = c.object({
  countries: c.string().array().nonempty(),
  deliveryTime: be.array().min(1).max(1).optional(),
  region: c.string().optional(),
  shippingRateMin: c.string(),
  shippingRateMax: c.string(),
  freeShippingThreshold: c.string().optional(),
  shippingSettingsLink: c.object({
    href: c.string()
  }).optional()
});
function yn(e) {
  return ve.safeParse(e).success;
}
const Pe = ve.array().nonempty();
function j(e) {
  return Pe.safeParse(e).success;
}
function hn(e, t) {
  const i = Pe.safeParse(e);
  if (!i.success) {
    t == null || t(i.error);
    return;
  }
  return i.data;
}
const bt = (e) => {
  const { country: t, currencyCode: i } = R();
  return b(() => {
    if (!j(e))
      return;
    const s = /* @__PURE__ */ new Map();
    for (const a of e) {
      if (!a.countries.includes(t))
        continue;
      const u = a.countries.join("");
      if (s.has(u)) {
        console.warn(`Duplicate key ${u} in StructuredDataShippingRate`);
        continue;
      }
      let o = parseInt(
        a.shippingRateMin
      );
      isNaN(o) && (o = void 0);
      let r = parseInt(
        a.shippingRateMax
      );
      isNaN(r) && (r = void 0);
      let p;
      typeof o == "number" && typeof r == "number" && (p = {
        "@type": "MonetaryAmount",
        minValue: o,
        maxValue: r,
        currency: i
      }), pe(p) && s.set(u, p);
    }
    if (s.size !== 0)
      return s;
  }, [e, t, i]);
}, vt = (e) => {
  const { country: t } = R();
  return b(() => {
    if (!j(e))
      return;
    const i = /* @__PURE__ */ new Map();
    for (const s of e) {
      if (!s.countries.includes(t))
        continue;
      const a = s.countries.join("");
      if (i.has(a)) {
        console.warn(`Duplicate key ${a} in StructuredDataShippingRate`);
        continue;
      }
      const u = {
        "@type": "DefinedRegion",
        addressCountry: t
      };
      typeof s.region == "string" && s.region.length > 0 && (u.addressRegion = s.region), Je(u) && i.set(a, u);
    }
    if (i.size !== 0)
      return i;
  }, [e, t]);
}, Pt = (e) => {
  const { country: t } = R();
  return b(() => {
    var s;
    if (!j(e))
      return;
    const i = /* @__PURE__ */ new Map();
    for (const a of e) {
      if (!a.countries.includes(t))
        continue;
      const u = a.countries.join("");
      if (i.has(u)) {
        console.warn(`Duplicate key ${u} in StructuredDataShippingRate`);
        continue;
      }
      if (typeof a > "u" || !Array.isArray(a.deliveryTime) || typeof a.deliveryTime[0] > "u")
        continue;
      const [o] = a.deliveryTime, r = {
        "@type": "ShippingDeliveryTime",
        businessDays: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "https://schema.org/Monday",
            "https://schema.org/Tuesday",
            "https://schema.org/Wednesday",
            "https://schema.org/Thursday",
            "https://schema.org/Friday"
          ]
        }
      };
      if (o.handlingTime.isEnabled === !0 && (r.handlingTime = {
        "@type": "QuantitativeValue",
        minValue: o.handlingTime.startTime,
        maxValue: o.handlingTime.endTime,
        unitCode: o.handlingTime.unit
      }, r.handlingTime = se(r.handlingTime)), o.transitTime.isEnabled === !0 && (r.transitTime = {
        "@type": "QuantitativeValue",
        minValue: o.transitTime.startTime,
        maxValue: o.transitTime.endTime,
        unitCode: o.transitTime.unit
      }, r.transitTime = se(r.transitTime)), typeof o.cutoffTime == "string" && /(([0-1][0-9])|(2[0-3])):[0-5][0-9]/.test(o.cutoffTime)) {
        const [p, d] = o.cutoffTime.split(
          ":"
        );
        let m = parseInt(p);
        (isNaN(m) || m > 23 || m < 0) && (m = void 0);
        let l = parseInt(d);
        if ((isNaN(l) || l > 59 || l < 0) && (l = void 0), typeof m < "u") {
          const g = /* @__PURE__ */ new Date();
          g.setUTCHours(m, l ?? 0, 0, 0), r.cutoffTime = (s = g.toJSON().split("T")) == null ? void 0 : s[1];
        }
      }
      Object.values(r ?? {}).filter((p) => typeof p < "u").length < 1 || et(r) && i.set(u, r);
    }
    if (i.size !== 0)
      return i;
  }, [e, t]);
}, Y = (e) => {
  const t = bt(
    e
  ), i = vt(
    e
  ), s = Pt(
    e
  ), { country: a, baseUrl: u } = R();
  return b(() => {
    if (!j(e) || typeof i > "u" || typeof t > "u" || typeof s > "u")
      return;
    const o = /* @__PURE__ */ new Map();
    for (const r of e) {
      if (!r.countries.includes(a))
        continue;
      const p = r.countries.join("");
      if (o.has(p)) {
        console.warn(`Duplicate key ${p} in OfferShippingDetails`);
        continue;
      }
      const d = t.get(p), m = i.get(p), l = s.get(p);
      if (typeof d > "u" || typeof m > "u" || typeof l > "u")
        return;
      const g = r == null ? void 0 : r.shippingSettingsLink, S = {
        "@type": "OfferShippingDetails",
        shippingDestination: m,
        deliveryTime: l,
        // @ts-expect-error - setting shippingRate to undefined is intentional
        shippingRate: void 0
      };
      g && (S.shippingSettingsLink = `${u}${g.href}`), pe(d) && (S.shippingRate = d), nt(S) && o.set(p, S);
    }
    if (o.size !== 0)
      return o;
  }, [
    e,
    t,
    i,
    s,
    a,
    u
  ]);
};
function ae(e) {
  if (typeof e != "string")
    return !1;
  try {
    new URL(e);
  } catch {
    return !1;
  }
  return !0;
}
function ue(e, t, i, s, a = !0, u, o) {
  var te, ne, I, ie;
  const r = {
    "@type": "Product",
    name: e.name
  }, p = e.sku, d = e.name, m = e.description, l = e.countryOfOrigin, g = e.priceAsNumber, S = e.brandName, A = (te = e.imageUrls) == null ? void 0 : te.filter((f) => ae(f)), E = e.urlSlug;
  if (typeof p > "u") {
    console.warn(
      `[useStructuredDataProduct]: Invalid sku for product, got ${p}. Product object: `,
      e
    );
    return;
  }
  let O = 1 / 0, M = 0;
  for (let f = 0; f < e.variants.length; ++f) {
    const h = e.variants[f];
    if (typeof h > "u")
      continue;
    const v = {
      "@type": "ProductModel"
    }, C = h.sku, L = h.size, W = h.ean, F = h.priceAsNumber ?? g;
    let x = (ne = h.imageUrls) == null ? void 0 : ne.filter((De) => ae(De));
    if (typeof x > "u" && (x = A), typeof C == "string" && C.length > 0)
      v.sku = C;
    else {
      console.warn(
        `[useStructuredDataProduct]: Invalid sku for variant, got ${C}. Variant object: `,
        h
      );
      continue;
    }
    typeof d == "string" && d.length > 0 && (v.name = d), typeof L == "string" && L.length > 0 && (typeof h.sizeSystem == "string" && h.sizeSystem.length > 0 ? v.size = {
      "@type": "SizeSpecification",
      name: L,
      sizeSystem: h.sizeSystem
    } : v.size = L), typeof W == "string" && W.length > 0 && (v.mpn = W), c.string().nonempty().array().nonempty().safeParse(x).success && (v.image = x), typeof t == "string" && t.length > 0 && typeof F == "number" && typeof h.quantity == "number" && (v.offers = {
      "@type": "Offer",
      price: F,
      priceCurrency: t,
      availability: h.quantity > 0 ? "InStock" : "OutOfStock",
      ...o && { shippingDetails: o }
    }, O = Math.min(O, F), M = Math.max(O, F));
    const Q = h.urlSlug ?? e.urlSlug;
    typeof i == "string" && i.length > 0 && typeof Q == "string" && Q.length > 0 && (v.url = `${i}/${s}/${Q}`);
    const re = ot(v);
    typeof re > "u" || (r.model = [
      re,
      ...r.model ?? []
    ]);
  }
  typeof S == "string" && S.length > 0 && (r.brand = {
    "@type": "Brand",
    name: S
  }), typeof p == "string" && p.length > 0 && (r.sku = p), typeof d == "string" && d.length > 0 && (r.name = d), typeof m == "string" && m.length > 0 && (r.description = m), typeof t == "string" && t.length > 0 && typeof r.model < "u" && (typeof g == "number" || typeof O == "number" && typeof M == "number") ? r.offers = {
    "@type": "AggregateOffer",
    lowPrice: typeof O == "number" ? O : g,
    highPrice: typeof M == "number" ? M : g,
    priceCurrency: t,
    availability: r.model.some(
      (f) => f.offers.availability === "InStock"
    ) ? "InStock" : "OutOfStock"
  } : typeof r.model > "u" && typeof t == "string" && t.length > 0 && typeof g == "number" && (r.offers = {
    "@type": "Offer",
    price: g,
    priceCurrency: t,
    availability: (ie = (I = e.variants) == null ? void 0 : I.some) != null && ie.call(
      I,
      (f) => typeof (f == null ? void 0 : f.quantity) == "number" && (f == null ? void 0 : f.quantity) > 0
    ) ? "InStock" : "OutOfStock",
    ...o && { shippingDetails: o }
  }), typeof i == "string" && i.length > 0 && typeof E == "string" && E.length > 0 && (r.url = `${i}/${s}/${E}`), typeof A < "u" && c.string().array().nonempty().safeParse(A).success && (r.image = A), typeof l == "string" && l.length > 0 && (r.countryOfOrigin = {
    "@type": "Country",
    name: l
  });
  const T = a ? e.aggregateRating : void 0, V = a ? e.reviews : void 0;
  return T && (r.aggregateRating = {
    "@type": "AggregateRating",
    ratingValue: T.ratingValue,
    bestRating: T.bestRating,
    worstRating: T.worstRating,
    reviewCount: T.reviewCount,
    ratingCount: T.ratingCount
  }), V && V.length > 0 && (r.review = V.map((f) => ({
    "@type": "Review",
    reviewBody: f.reviewBody,
    reviewRating: f.reviewRating ? {
      "@type": "Rating",
      ratingValue: f.reviewRating.ratingValue,
      bestRating: f.reviewRating.bestRating,
      worstRating: f.reviewRating.worstRating
    } : void 0,
    author: f.author ? {
      "@type": f.author.type,
      name: f.author.name
    } : void 0,
    datePublished: f.datePublished,
    name: f.name,
    description: f.description,
    reviewAspect: f.reviewAspect,
    positiveNotes: f.positiveNotes,
    negativeNotes: f.negativeNotes
  }))), u && (r.hasMerchantReturnPolicy = u), gt(r);
}
function Re(e) {
  const { currencyCode: t, baseUrl: i, siteSlug: s, country: a } = R(), u = Be(), o = $e(), r = St(
    u
  ), p = Y(
    o
  ), d = a, m = p == null ? void 0 : p.get(d);
  return b(() => {
    if (!(typeof e > "u" || typeof t > "u" || typeof i > "u" || typeof s > "u"))
      if (Array.isArray(e)) {
        if (e.length === 0)
          return;
        const l = {
          "@type": "ItemList",
          itemListElement: []
        };
        for (let g = 0; g < e.length; ++g) {
          const S = e[g];
          typeof S > "u" || l.itemListElement.push({
            "@type": "ListItem",
            position: g + 1,
            item: ue(
              S,
              t,
              i,
              s,
              !1,
              // Don't include reviews for product lists
              r,
              m
            )
          });
        }
        return yt(l) ? l : void 0;
      } else
        return ue(
          e,
          t,
          i,
          s,
          !0,
          // Include reviews for single product (PDP)
          r,
          m
        );
  }, [
    e,
    t,
    i,
    s,
    r,
    m
  ]);
}
const Rt = ({
  unformattedProducts: e
}) => {
  const t = Re(e), i = Me(0);
  return Ie(() => {
    i.current += 1;
  }, [t]), typeof t > "u" ? null : /* @__PURE__ */ y(
    D,
    {
      item: {
        "@context": "https://schema.org",
        ...t
      }
    },
    i.current
  );
}, wt = ({ settings: e }) => {
  const t = Y(e);
  return /* @__PURE__ */ y($, { children: [...(t == null ? void 0 : t.entries()) ?? []].map(
    ([i, s]) => /* @__PURE__ */ y(
      D,
      {
        item: {
          "@context": "https://schema.org",
          ...s
        }
      },
      i
    )
  ) });
}, Ot = n.object({
  "@type": n.literal("ShippingRateSettings"),
  shippingRate: U,
  freeShippingThreshold: U,
  shippingDestination: B
}), we = Ot;
function Tt(e) {
  const t = we.safeParse(e);
  return t.success, t.success;
}
function Sn(e) {
  const t = we.safeParse(e);
  if (t.success)
    return t.data;
}
const kt = ({ settings: e }) => {
  const { country: t, currencyCode: i, currentPath: s } = R(), a = Y(e), u = b(() => {
    var r;
    if (!j(e) || typeof a > "u")
      return;
    const o = /* @__PURE__ */ new Map();
    for (const p of e) {
      if (!p.countries.includes(t))
        continue;
      const d = p.countries.join(""), m = a.get(d);
      if (typeof m > "u" || ((r = p.shippingSettingsLink) == null ? void 0 : r.href) !== s)
        continue;
      const l = {
        ...m,
        "@type": "ShippingRateSettings"
      };
      if (delete l.deliveryTime, delete l.shippingSettingsLink, typeof p.freeShippingThreshold == "string") {
        let g = parseFloat(
          p.freeShippingThreshold
        );
        isNaN(g) && (g = void 0), typeof g < "u" && (l.freeShippingThreshold = {
          "@type": "MonetaryAmount",
          value: g,
          currency: i
        });
      }
      if (o.has(d)) {
        console.warn(`Duplicate key ${d} in ShippingRateSettings`);
        continue;
      }
      Tt(l) && o.set(d, l);
    }
    if (o.size !== 0)
      return o;
  }, [a, e]);
  return /* @__PURE__ */ y($, { children: [...(u == null ? void 0 : u.entries()) ?? []].map(
    ([o, r]) => /* @__PURE__ */ y(
      D,
      {
        item: {
          "@context": "https://schema.org",
          ...r
        }
      },
      o
    )
  ) });
}, bn = ({
  offerShippingDetailsSettings: e
}) => {
  const t = Qe(), i = Ve();
  return /* @__PURE__ */ je($, { children: [
    Object.entries(i).filter(([s]) => !(typeof t < "u" && s === k.ProductList)).map(([, s]) => s),
    /* @__PURE__ */ y(He, {}),
    /* @__PURE__ */ y(wt, { settings: e }),
    /* @__PURE__ */ y(
      kt,
      {
        settings: e
      }
    ),
    /* @__PURE__ */ y(Rt, { unformattedProducts: t })
  ] });
}, Dt = n.object({
  "@type": n.literal("FAQPage"),
  mainEntity: n.array(
    n.object({
      "@type": n.literal("Question"),
      name: n.string(),
      acceptedAnswer: n.object({
        "@type": n.literal("Answer"),
        text: n.string()
      })
    })
  ).nonempty()
}), jt = Dt;
function At(e) {
  const t = jt.safeParse(e);
  return t.success, t.success;
}
const Z = (e, t) => {
  const i = We(), s = Ce();
  Le(
    () => {
      if (typeof e > "u")
        return;
      const a = `schema-org-script-${e.name ?? e["@type"] ?? t}-${s}`, u = /* @__PURE__ */ y(
        D,
        {
          item: {
            "@context": "https://schema.org",
            ...e
          }
        },
        a
      );
      i(t, u);
    },
    {
      ifDefined: [e]
    }
  );
}, Mt = (e) => {
  if (e.length === 0)
    return;
  const t = {
    "@type": "FAQPage"
  };
  let i = [];
  for (const { q: s, a } of e) {
    if (typeof s != "string" || typeof a != "string") {
      console.warn("[useInjectFAQPage]: Wrong input, got", { q: s, a });
      continue;
    }
    i = [
      ...i,
      {
        "@type": "Question",
        name: s,
        acceptedAnswer: {
          "@type": "Answer",
          text: a
        }
      }
    ];
  }
  if (t.mainEntity = i, !At(t)) {
    console.warn(
      "[useInjectFAQPage]: Could not generate FAQ Page structured data from: ",
      e,
      " generated: ",
      t,
      ", which is not valid SchemaOrg format"
    );
    return;
  }
  return t;
}, vn = (e) => {
  const t = b(() => {
    if (!(typeof e > "u"))
      return Mt(e);
  }, [e]);
  Z(t, k.FAQPage);
}, Pn = (e) => {
  const t = Re(e);
  Z(
    t,
    lt(t) ? k.Product : k.ProductList
  );
}, It = n.object({
  "@type": n.literal("SearchAction"),
  target: n.object({
    "@type": n.literal("EntryPoint"),
    urlTemplate: n.string()
  }),
  "query-input": n.string()
}), Oe = It;
function Rn(e) {
  return Oe.safeParse(e).success;
}
const Ct = n.object({
  "@type": n.literal("ImageObject"),
  url: n.string(),
  contentUrl: n.string().optional(),
  caption: n.string().optional(),
  inLanguage: n.string().optional()
}), Te = Ct;
function wn(e) {
  return Te.safeParse(e).success;
}
const Lt = n.object({
  "@type": n.literal("WebSite"),
  "@context": n.literal("https://schema.org/"),
  url: n.string(),
  name: n.string(),
  description: n.string().optional(),
  inLanguage: n.string().optional(),
  keywords: n.string().optional(),
  potentialAction: Oe.optional(),
  logo: Te.optional(),
  sameAs: n.array(n.string()).optional()
}), Ft = Lt;
function xt(e) {
  return Ft.safeParse(e).success;
}
const Ut = (e) => {
  const t = {
    "@type": "WebSite",
    "@context": "https://schema.org/",
    url: e.url,
    name: e.name
  };
  if (e.description && (t.description = e.description), e.inLanguage && (t.inLanguage = e.inLanguage), e.keywords && (t.keywords = e.keywords), e.searchActionUrlTemplate && (t.potentialAction = {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: e.searchActionUrlTemplate
    },
    "query-input": "required name=search_term_string"
  }), e.logoUrl && (t.logo = {
    "@type": "ImageObject",
    url: e.logoUrl,
    contentUrl: e.logoUrl
  }, e.logoCaption && (t.logo.caption = e.logoCaption), e.logoLanguage && (t.logo.inLanguage = e.logoLanguage)), e.sameAs && e.sameAs.length > 0 && (t.sameAs = e.sameAs), !xt(t)) {
    console.warn(
      "[useInjectWebSite]: Could not generate WebSite structured data from: ",
      e,
      " generated: ",
      t,
      ", which is not valid SchemaOrg format"
    );
    return;
  }
  return t;
}, On = (e) => {
  const t = b(() => {
    if (!(typeof e > "u"))
      return Ut(e);
  }, [e]);
  Z(t, k.WebSite);
}, zt = n.object({
  a: n.string(),
  q: n.string()
}), ke = n.object({
  qa: n.array(zt)
});
function Tn(e) {
  return ke.safeParse(e).success;
}
function kn(e) {
  const t = ke.safeParse(e);
  if (t.success)
    return t.data;
}
const Dn = n.object({
  name: n.string(),
  description: n.string().optional(),
  keywords: n.string().optional(),
  logoUrl: n.string(),
  logoCaption: n.string().optional(),
  sameAs: n.string().optional()
}), Nt = c.object({
  sku: c.string(),
  name: c.string(),
  uri: c.string(),
  excerpt: c.string().optional(),
  brand: c.string().optional(),
  countryOrigin: c.string().optional().nullable(),
  price: c.object({
    priceAsNumber: c.number()
  }),
  mediaUrls: c.array(c.string()),
  frontendItems: c.array(
    c.object({
      sku: c.string(),
      name: c.string(),
      ean: c.string().optional(),
      quantity: c.number().optional()
    })
  )
});
function Et(e) {
  const t = Nt.safeParse(e);
  return t.success || console.warn(
    "Type validation of StructuredDataFormattableCentraProduct failed: ",
    t.error
  ), t.success;
}
function jn(e) {
  if (!(typeof e > "u") && Et(e))
    return {
      sku: e.sku,
      name: e.name,
      description: e.excerpt,
      brandName: e.brand,
      priceAsNumber: e.price.priceAsNumber,
      imageUrls: e.mediaUrls,
      countryOfOrigin: e.countryOrigin,
      urlSlug: e.uri,
      variants: e.frontendItems.map((t) => ({
        sku: t.sku,
        size: t.name,
        ean: t.ean,
        imageUrls: e.mediaUrls,
        quantity: t.quantity
      }))
    };
}
function An(e) {
  switch (e.dataModel) {
    case "simple":
      return Vt(e);
    case "with_variants":
      return Wt(e);
    case "bundle":
      return Qt(e);
    default:
      throw new Error("Unsupported product type" + e.dataModel);
  }
}
function Vt(e) {
  const t = ee(e);
  return {
    sku: e.sku,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: e.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: [
      {
        sku: e.sku,
        size: "One size",
        ean: e.ean,
        imageUrls: t,
        quantity: e.inventory.quantity
      }
    ]
  };
}
function Wt(e) {
  var i;
  const t = ee(e);
  return {
    sku: e.base.productId,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: (i = e.variants[0]) == null ? void 0 : i.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: e.variants.map((s) => ({
      sku: s.sku,
      size: s.label,
      ean: s.ean,
      imageUrls: t,
      quantity: s.inventory.quantity
    }))
  };
}
function Qt(e) {
  const t = ee(e);
  return {
    sku: e.bundlePurchaseInfo.sku,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: e.bundlePurchaseInfo.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: [
      {
        sku: e.bundlePurchaseInfo.sku,
        size: "Bundle",
        imageUrls: t,
        quantity: e.bundlePurchaseInfo.inventory.quantity
      }
    ]
  };
}
function ee(e) {
  return e.base.content.media.filter(Fe).map((t) => t.src);
}
export {
  Ee as GearsStructuredDataContextProvider,
  bn as GearsStructuredDataHeadTag,
  He as StructuredDataBreadcrumbs,
  Rt as StructuredDataProducts,
  Jt as StructuredDataProvider,
  k as StructuredDataScriptName,
  wt as StructuredDataShippingDetails,
  kt as StructuredDataShippingRateSettings,
  ge as aggregateOfferSchema,
  _ as aggregateRatingSchema,
  Ue as breadcrumbListSchema,
  fe as dayOfWeekSchema,
  jn as defaultMapCentraProductToStructuredDataProduct,
  B as definedRegionSchema,
  jt as faqPageSchema,
  An as greaseProductToUnformattedStructuredDataProduct,
  Te as imageObjectSchema,
  rn as isAggregateOffer,
  sn as isAggregateRating,
  ze as isBreadcrumbList,
  en as isDayOfWeek,
  Je as isDefinedRegion,
  At as isFAQPage,
  wn as isImageObject,
  Yt as isItemAvailability,
  fn as isMerchantReturnPolicy,
  ht as isMerchantReturnPolicySettings,
  ln as isMerchantReturnPolicySettingsEntry,
  pe as isMonetaryAmount,
  tn as isOffer,
  nt as isOfferShippingDetails,
  j as isOfferShippingDetailsSettings,
  yn as isOfferShippingDetailsSettingsEntry,
  lt as isProduct,
  yt as isProductList,
  nn as isProductModel,
  Zt as isQuantitativeValue,
  an as isRating,
  cn as isReview,
  Rn as isSearchAction,
  et as isShippingDeliveryTime,
  mn as isShippingDeliveryTimeSetting,
  Tt as isShippingRateSettings,
  Tn as isStoryblokFAQPage,
  xt as isWebSite,
  q as itemAvailabilitySchema,
  me as merchantReturnPolicySchema,
  he as merchantReturnPolicySettingsEntrySchema,
  Se as merchantReturnPolicySettingsSchema,
  U as monetaryAmountSchema,
  H as offerSchema,
  le as offerShippingDetailsSchema,
  ve as offerShippingDetailsSettingsEntrySchema,
  Pe as offerShippingDetailsSettingsSchema,
  ye as productListSchema,
  G as productModelSchema,
  X as productSchema,
  z as quantitativeValueSchema,
  K as ratingSchema,
  J as reviewSchema,
  Oe as searchActionSchema,
  de as shippingDeliveryTimeSchema,
  be as shippingDeliveryTimeSettingSchema,
  we as shippingRateSettingsSchema,
  oe as storyblokTimeRangeFieldTypeSchema,
  w as structuredDataContext,
  on as toAggregateRatingOrUndefined,
  gn as toMerchantReturnPolicySettingsOrUndefined,
  hn as toOfferShippingDetailsSettingsOrUndefined,
  dn as toProductListOrUndefined,
  ot as toProductModelOrUndefined,
  gt as toProductOrUndefined,
  se as toQuantitativeValueOrUndefined,
  un as toRatingOrUndefined,
  pn as toReviewOrUndefined,
  Sn as toShippingRateSettingsOrUndefined,
  kn as toStoryblokFAQPageOrUndefined,
  We as useAddGearsStructuredDataHeadTagScript,
  qe as useBreadCrumbs,
  Ve as useGearsStructuredDataHeadTagScripts,
  vn as useInjectFAQPage,
  Pn as useInjectStructuredDataProducts,
  On as useInjectWebSite,
  Be as useMerchantReturnPolicySettings,
  Qe as usePdpProduct,
  Kt as useRemoveGearsStructuredDataHeadTagScript,
  $e as useShippingDetailsSettings,
  R as useStructuredDataContext,
  Z as useStructuredDataInjector,
  Xt as useStructuredDataMappers,
  St as useStructuredDataMerchantReturnPolicy,
  Y as useStructuredDataOfferShippingDetails,
  Re as useStructuredDataProduct,
  Pt as useStructuredDataShippingDeliveryTime,
  vt as useStructuredDataShippingDestination,
  bt as useStructuredDataShippingRate,
  Ft as webSiteSchema,
  Dn as webSiteSettingsSchema
};
